import queryString from "query-string"

export function getQueryProducts() {
  const queryObj = queryString.parse(window.location.search)
  const products = Array.isArray(queryObj.products)
    ? queryObj.products
    : [queryObj.products].filter((p) => p)
  return {
    products,
    chainBaseProduct: queryObj.chainBaseProduct,
    chainVariantCode: queryObj.chainVariantCode,
    allCodes: products
      .concat([queryObj.chainBaseProduct, queryObj.chainVariantCode])
      .filter((p) => p),
  }
}
